import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../types/types';
import { ISnackbarHOCProps } from './types';
import { Snackbar } from '../../components/Snackbar/Snackbar';
import { ISnackbarFields } from '../../components/Snackbar/types';
import { getSnackbar } from '../../selectors/getSnackbar';

const mapStateToProps = (
    state: IApplicationState,
    { snackbarId }: ISnackbarHOCProps
): ISnackbarFields => {
    const snackbar = getSnackbar(state, snackbarId)
    return {
        ...snackbar,
        timer: snackbar.timer && snackbar.timer < 0 ? null : snackbar.timer,
    };
};

export const SnackbarHOC = connect(mapStateToProps, null)(Snackbar);
SnackbarHOC.displayName = 'SnackbarHOC';
